import pad from '@utils/string/pad'

const simpleDate = (timestamp, forHtml = false) => {
    if (timestamp === null) return null
    const d = new Date(timestamp)
    if (isNaN(d.getTime())) return null
    return forHtml
        ? `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
        : `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} r.`
}

export default simpleDate